import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Chip,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

export default function CalendarBookingDetailDialog({
  dateKey,
  items,
  open,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {dateKey && (
        <>
          <DialogTitle sx={{ p: 0 }}>
            <Box
              sx={{
                px: 2.5,
                py: 1.4,
                backgroundColor: "#F5F7FA",
                borderBottom: "1px solid #E8E8E8",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Typography
                  sx={{ fontWeight: 700, fontSize: 16, color: "#1565C0" }}
                >
                  {dayjs(dateKey).format("ddd, DD MMM YYYY")}
                </Typography>
                <Chip
                  label={`${items.length} booking${items.length !== 1 ? "s" : ""}`}
                  size="small"
                  sx={{
                    fontWeight: 600,
                    fontSize: 12,
                    backgroundColor: "#1976D2",
                    color: "#fff",
                    height: 24,
                  }}
                />
              </Box>
              <IconButton size="small" onClick={onClose}>
                <CloseIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ p: 0 }}>
            {items.map((item, idx) => (
              <Box key={item._id}>
                {idx > 0 && <Divider />}
                <Box sx={{ px: 2.5, py: 1.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 0.8,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: 600, fontSize: 13, color: "#1565C0" }}
                    >
                      {item.booking_number}
                    </Typography>
                    <Chip
                      label={item.day_index}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        fontSize: 10,
                        backgroundColor: "#EBF4FF",
                        color: "#1565C0",
                        height: 20,
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.3,
                    }}
                  >
                    {[
                      { label: "Customer", value: item.customer_name },
                      { label: "Itinerary", value: item.activity_label },
                      { label: "Activities", value: item.activity_detail },
                      { label: "Accom", value: item.accommodation_label },
                    ].map((row) => (
                      <Box
                        key={row.label}
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#999",
                            fontWeight: 600,
                            minWidth: 70,
                            textTransform: "uppercase",
                            letterSpacing: "0.3px",
                            fontSize: 10,
                          }}
                        >
                          {row.label}
                        </Typography>
                        <Typography sx={{ fontSize: 12, fontWeight: 500 }}>
                          {row.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            ))}
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}
